var $ = require('jquery');
require('./jquery.simplyscroll.min');

var el = document.querySelector('#scroller');

$(el).simplyScroll({
  speed: 1
});

console.log($(el).data());


//////////////////
// WEBPACK FOOTER
// /Users/iclip-imac/Desktop/web/node_modules/jquery-simplyscroll/index.js
// module id = 9
// module chunks = 0